export function isMinor(dateOfBirth: string, today = new Date()): boolean {
  if (!dateOfBirth) return false
  const dob = new Date(dateOfBirth)
  let age = today.getFullYear() - dob.getFullYear()
  const beforeBirthday = today.getMonth() < dob.getMonth() || (today.getMonth() === dob.getMonth() && today.getDate() < dob.getDate())
  if (beforeBirthday) age--
  return age < 18
}
